import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { useContext } from "react";

export declare type UpdatePromptProps = {
  onUpdate: (reloadPage?: boolean) => Promise<void>;
};

export default function UpdatePrompt({ onUpdate }: UpdatePromptProps) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang } = useContext(PspContext);

  return (
    <>
      <Dialog open={true}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{translate("newUpdateAvailable", lang)}</DialogTitle>
            <DialogContent>{translate("clickToUpdate", lang)}</DialogContent>
          </DialogBody>
          <DialogActions>
            <DialogTrigger>
              <Button appearance="primary" onClick={() => onUpdate(true)}>
                {translate("update", lang)}
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogSurface>
      </Dialog>
    </>
  );
}
